type PartnerConfig = "DEFAULT" | "BENUP";

enum FluxoType {
  AUTOSSERVICO = "Autosserviço",
  CONSULTOR = "Consultor",
  INDICACAO = "Indicação"
}

enum Publico {
  PESSOA_FISICA = "PF",
  PESSOA_JURIDICA = "PJ",
  MISTO = "Misto"
}

export type Partner = {
  id: string;
  nome: string;

  fluxo: {
    tipo: FluxoType;
    id: string;
    publico: Publico;
    podeEscolherPlano: boolean;
    podeAplicarCupom: boolean;
  }
};

export type { PartnerConfig };
export { FluxoType, Publico };
